import { render, staticRenderFns } from "./InfoBoard.vue?vue&type=template&id=40ab014e&scoped=true&"
import script from "./InfoBoard.vue?vue&type=script&lang=js&"
export * from "./InfoBoard.vue?vue&type=script&lang=js&"
import style0 from "./InfoBoard.vue?vue&type=style&index=0&id=40ab014e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40ab014e",
  null
  
)

export default component.exports